/* eslint-disable @typescript-eslint/no-shadow */
import {
  cloneDeep, find, indexOf, pull, includes,
} from 'lodash-es';

import apiUrls from '@/apiUrls.config';
import { mapRequiredFiltryBoczne, mapCleanWybrane } from '@/storeServices/filtry';
import filtryBoczneClicked from '~/googleTagManager/listing/filtry-boczne-clicked';
import ETypyWyjazdu from '~/types/ETypyWyjazdu';

import { makeMutations } from '../helper-functions/store/store';
import { filterChilds } from '../storeServices/filtry';

export const state = () => ({
  filtry: [],
  wybrane: {},
  showWidgetLastMinute: false,
});
const getWybraneIlosc = (wybrane) => {
  const res = wybrane
    ? Object.values(wybrane)
      .filter((x) => Array.isArray(x) && x && x.length > 0)
      .flat()
    : [];

  return res.length;
};
export const getters = {
  wybraneIlosc: (state) => getWybraneIlosc(state.wybrane),
  polaDlaGTMV4: (state) => ({
    wybrane: state.wybrane,
    filtry: state.filtry,
  }),
};
export const mutations = {
  ...makeMutations(['filtry', 'wybrane', 'showWidgetLastMinute']),
  changeWybraneValue(state, payload) {
    state.wybrane[payload.name] = { ...state.wybrane[payload.name], ...payload.value };
  },
  setWybrane(state, payload) {
    state.wybrane[payload.name] = payload.value;
  },
  resetWybrane(state, payload) {
    if (payload.czyMultiSelect) {
      const index = indexOf(state.wybrane[payload.keyParent], payload.wartosc);

      state.wybrane[payload.keyParent].splice(index, 1);

      if (payload.keyParent === ETypyWyjazdu.typWartosc) {
        if (payload.wartosc === ETypyWyjazdu.objazd && includes(state.wybrane[payload.keyParent], ETypyWyjazdu.objazdPotwierdzony)) {
          pull(state.wybrane[payload.keyParent], ETypyWyjazdu.objazdPotwierdzony);
        }

        if (
          payload.wartosc === ETypyWyjazdu.objazdWypoczynek
          && includes(state.wybrane[payload.keyParent], ETypyWyjazdu.objazdWypoczynekPotwierdzony)
        ) {
          pull(state.wybrane[payload.keyParent], ETypyWyjazdu.objazdWypoczynekPotwierdzony);
        }
      }
    } else {
      const key = Object.keys(state.wybrane[payload.keyParent]).find((key) => state.wybrane[payload.keyParent][key] === payload.wartosc);

      if (key === 'selected' || payload.wartosc === '*-*') {
        const dostepnePola = find(state.filtry, { Wartosc: payload.keyParent });
        const defaultValue = find(dostepnePola.Pola, 'CzyDefault');

        state.wybrane[payload.keyParent].selected = defaultValue.Wartosc;
      } else {
        if (payload.keyParent === 'DlugoscPobytu') {
          // set default value, toggle radio-filter
          const dostepnePola = find(state.filtry, { Wartosc: payload.keyParent });
          const defaultValue = find(dostepnePola.Pola, 'CzyDefault');

          state.wybrane[payload.keyParent].selected = defaultValue.Wartosc;
        }

        const array = delete state.wybrane[payload.keyParent][key];

        state.wybrane[payload.keyParent] = { ...state.wybrane[payload.keyParent], ...array };
      }
    }
  },
};

export const actions = {
  async fetchFilters(context) {
    if (context.state.filtry.length !== 0) {
      return;
    }

    const response = await this.$http.get(`${apiUrls.filtry}pobierz-filtry-boczne`);
    const responseJson = await response.json();
    const filtryBoczneBezPopularnych = responseJson.filter((section) => !section.CzyOminWyszukiwanie);
    const cleanWybrane = await mapCleanWybrane(filtryBoczneBezPopularnych);

    context.commit('wybrane', cleanWybrane);
    context.commit('filtry', filtryBoczneBezPopularnych);
    mapRequiredFiltryBoczne(context.state.filtry, context);
  },
  async toggleCheckbox(context, payload) {
    filtryBoczneClicked();
    const targetArray = cloneDeep(context.state.wybrane[payload.name]);

    if (!targetArray) {
      console.warn('Wrong state name', payload.name);
    }

    context.commit('setWybrane', {
      name: payload.name,
      value: filterChilds({
        targetArray,
        payload,
        filtry: context.state.filtry,
      }),
    });

    const response = await this.$http.$post(`${apiUrls.routing}/czy-kalendarzyk`, {
      AtrybutyMulti: { Promocja: context.state.wybrane.Promocja },
    });

    context.commit('showWidgetLastMinute', response.KalendarzykLastMinute);
  },
  async clearWybrane(context) {
    const cleanWybrane = mapCleanWybrane(context.state.filtry);

    context.commit('wybrane', cleanWybrane);
    mapRequiredFiltryBoczne(context.state.filtry, context);
  },
  changeWybraneValue(context, payload) {
    filtryBoczneClicked();
    context.commit('changeWybraneValue', payload);
  },
};
